module.exports = __webpack_public_path__ + "static/media/lp-img-5.421d735f.png";